import React, { type ReactNode, useRef, type FC } from 'react';
import Button from '@atlaskit/button';
import FeedbackIcon from '@atlaskit/icon/core/migration/feedback';
import { Box, Text } from '@atlaskit/primitives/compiled';
import { ENTRY_POINT_ID_JSM_VIRTUAL_AGENT } from '@atlassian/jira-feedback-collector/src/constants.tsx';
import { useFeedbackCollectorActions } from '@atlassian/jira-feedback-collector/src/controllers/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { MenuItem } from '@atlassian/jira-navigation-apps-sidebar-common/src/common/ui/menu-item/main.tsx';
import messages from './messages.tsx';

const FeedbackTitleDetails: FC = () => {
	const { formatMessage } = useIntl();

	return (
		<Box>
			<Text as="p">{formatMessage(messages.feedbackTitleDetails)}</Text>
			<Text as="p">
				{formatMessage(messages.feedbackTitleDetailsContactSupport, {
					link: (chunks: ReactNode[]) => (
						<Button
							appearance="link"
							spacing="none"
							target="_blank"
							rel="noopener noreferrer"
							href="https://support.atlassian.com/contact"
						>
							{chunks}
						</Button>
					),
				})}
			</Text>
		</Box>
	);
};

export const FeedbackMenuItem: FC = () => {
	const { openFeedbackCollector } = useFeedbackCollectorActions();

	const feedbackButtonRef = useRef<HTMLButtonElement>(null);
	const { formatMessage } = useIntl();

	return (
		<MenuItem
			iconBefore={<FeedbackIcon spacing="spacious" label="" />}
			onClick={() =>
				openFeedbackCollector({
					feedbackGroupId: 'jira-servicedesk-project-settings-virtual-agent',
					entrypointId: ENTRY_POINT_ID_JSM_VIRTUAL_AGENT,
					triggerRef: feedbackButtonRef,
					feedbackTitle: formatMessage(messages.feedbackTitleV2),
					feedbackTitleDetails: <FeedbackTitleDetails />,
				})
			}
			ref={feedbackButtonRef}
		>
			{formatMessage(messages.feedbackMenuItem)}
		</MenuItem>
	);
};
